import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children, userType = 'customer', onCreateInstance }) => {
  return (
    <div className="flex h-screen bg-slate-900">
      {/* Sidebar */}
      <Sidebar userType={userType} />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar */}
        <div className="h-16 bg-slate-800 border-b border-slate-700 flex items-center justify-between px-6">
          <div className="flex items-center space-x-4">
            {/* Page title or breadcrumbs can go here */}
          </div>
          
          {/* Action Buttons */}
          <div className="flex items-center space-x-3">
            {userType === 'customer' && onCreateInstance && (
              <button 
                onClick={onCreateInstance}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
              >
                + Create Instance
              </button>
            )}
          </div>
        </div>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-slate-900">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
